import { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { useAuth } from './AuthContext';
import { getAuthToken } from '../utils/authToken';

interface SettingsValue {
  eurZar: number;
}

const SettingsContext = createContext<SettingsValue>({ eurZar: 19.3 });

export function SettingsProvider({ children }: { children: ReactNode }) {
  const [eurZar, setEurZar] = useState(19.3);
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;
    const fetchSettings = async () => {
      try {
        const token = getAuthToken();
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/settings`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.ok) {
          const data = await res.json();
          if (data?.eur_zar_rate) setEurZar(data.eur_zar_rate);
        }
      } catch (e) { /* use default */ }
    };
    fetchSettings();
  }, [user]);

  return (
    <SettingsContext.Provider value={{ eurZar }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings(): SettingsValue {
  return useContext(SettingsContext);
}
